import { render, staticRenderFns } from "./BigPerformanceChart.vue?vue&type=template&id=5f05b822&scoped=true&"
import script from "./BigPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./BigPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./BigPerformanceChart.vue?vue&type=style&index=0&id=5f05b822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05b822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCardActions,VChip,VCol,VDivider,VFadeTransition,VIcon,VRow,VSelect})
